<template>
    <v-menu v-model="menuDate" :close-on-content-click="false" :nudge-right="getNudgeRight()" offset-y transition="scale-transition" readonly>
        <template v-slot:activator="{ on }">
            <v-text-field ref="textfield" :class="[pickerprependicon!=='' ? 'picker' : '', `${fontsize}`]"
                :value="dateValue" 
                :label="label" 
                :readonly="!allowManualEditing" 
                :hint="pickerhint"
                :placeholder="pickerplaceholder" 
                :error-messages="errorMessages"
                :prepend-icon="pickerprependicon"            
                :dense="isDense"
                :clearable="isClearable"
                v-on:click="onClick($event)" 
                v-on:keydown="onKeydown($event)" 
                v-on:focus="onFocus($event)" 
                v-on:change="onChange($event)" 
                v-on:click:clear="onClear()"
                v-on:blur="onBlur($event)"
                v-on="on">
            </v-text-field>
        </template>
        <v-date-picker :first-day-of-week="1" @input="updateData" :show-current="syncDate" :picker-date.sync="syncDate" ></v-date-picker>
    </v-menu>
</template>

<script>
export default {
    props: {
        date: String, // iso-date format
        label: String,
        field: String,
        hint: String,
        placeholder: String,
        manual: Boolean,
        fontsize: {
            type: String,
            default: ''
        },
        icon: String,
        isDense:{
          type: Boolean,
          default: true
        },        
        startDate:{
            type: String,
            default: new Date().toISOString().substring(0, 10),
        },
        isClearable:{
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            menuDate: false,
            errorMessages: [],
            syncDate: ''
        }
    },
    computed: {
        dateValue() { // convert iso-dat to dmy before displaying
            return typeof this.date === 'undefined' || this.date === null || this.date === '' ? '' : this.$moment(this.date).format('DD-MM-YYYY');
        },
        allowManualEditing() {
            return typeof this.manual === 'undefined' || this.manual === null ? false : this.manual;
        },
        pickerhint() {
            return typeof this.hint === 'undefined' || this.hint === null ? '' : this.hint;
        },
        pickerplaceholder() {
            return typeof this.placeholder === 'undefined' || this.placeholder === null ? '' : this.placeholder;
        },
        pickerprependicon() {
            return typeof this.icon === 'undefined' || this.icon === null ? '' : this.icon;
        },        
    },
    mounted() {
        this.syncDate = this.getStartDate(); // iso-date
    },
    methods: {
        getStartDate(){
            //console.log('startdate', this.startDate, this.dateValue)
            if(typeof this.startDate === 'undefined' || this.startDate === null || this.startDate === ''){
                if (this.dateValue!=='' ){
                    let items = this.dateValue.split('-') // display date = dmy
                    return `${items[2]}-${items[1]}-${items[0]}` // convert to iso-date
                } else {
                    return new Date().toISOString().substring(0, 10) // iso-date
                }
            } else{
                if (this.dateValue!=='' ){
                    let items = this.dateValue.split('-') // display date = dmy
                    return `${items[2]}-${items[1]}-${items[0]}` // convert to iso-date
                }    
                return this.startDate // iso-date
            }
        },
        onClick() {
            this.syncDate = this.getStartDate()
            //console.log('syncdate', this.syncDate)
            //console.log('click', evt);
            this.errorMessages = [];
        },
        onClear(){
            // console.log('clear');
            this.errorMessages = []; // clear error on clear
            this.$emit('updateData', { "field": this.field, "value": null }); // always emit null value or the textfield will not be updated correctly
        },
        onBlur(evt){
           //console.log('blur', evt.target.value, this.menuDate===false);
           //this.menuDate=false
           this.menuDate===false ? this.checkInput(evt.target.value) : false;
        },
        onFocus(evt) {
            if(this.menuDate===false && this.manual===true){
                try {
                    evt.target.select();
                } catch (err) {
                    return;
                }
            }
        },
        onChange(v){        
            console.log('change', v);
            if(this.manual){
                if(String(v).length===10){
                    this.checkInput(v)
                }
            }
        },
        checkInput(v){
            // force format 99-99-9999 for display (not 99/99/9999)
            // console.log('blur', evt.target.value);

            const date_regex = /^(?:(?:31(-)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(-)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(-)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(-)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
            
            if(v === '' || v === null){
                this.errorMessages = [];
            } else {
                if (!date_regex.test(v) || String(v).length!==10){
                    this.errorMessages.push('Invalid date, correct format = dd-mm-yyyy');
                    this.$refs.textfield.focus();
                } else {                
                    this.errorMessages = []; // clear any errors after successful validation
                    this.updateData(v);
                }
            }
        },

        onKeydown(e) {

            console.log('change', e);

            let allowedalphakeys = [8, 9, 46, 35, 36, 37, 39]; // backspace, tab, delete, home, end, left, right 
            let allowedctrlkeys = [65, 67, 88, 86]; // ctrl-a, ctrl-c, ctrl-v, ctrl-x
            let allowednumpadkeys = [109]; // '-'

            if (!(
                ((e.keyCode >= 48 && e.keyCode <= 57) && !e.shiftKey)
                || (e.keyCode == 189 && !e.shiftKey)
                || (e.keyCode >= 96 && e.keyCode <= 105)
                || allowedalphakeys.includes(e.keyCode)
                || (allowedctrlkeys.includes(e.keyCode) && e.ctrlKey)
                || (allowednumpadkeys.includes(e.keyCode))
            )) {
                e.preventDefault();
            } else {
                this.errorMessages = []; // clear any errors when typing
            }

        },
        getNudgeRight(){
            return this.pickerprependicon === '' ? 40 : 60;
        },
        updateData(data) {
            // console.log('update', data);
            // manually entered format = dd-mm-yyyy, via picker format = yyyy-mm-dd. 
            // check format and convert dmy --> iso if needed
            const isodate_regex = /^\d{4}-([0]\d|1[0-2])-([0-2]\d|3[01])$/;
            !isodate_regex.test(data) ? data = data.split("-").reverse().join("-") : data; //  create an array of the dmy date, reverse it and join it again using the 'dash'...
            this.menuDate=false; // make sure the picker is unloaded
            this.$emit('updateData', { "field": this.field, "value": data }); // always emit iso-date
        }
    }
}
</script>

<style scoped>
    .picker {
        min-width: 145px !important;
    }
    .medium {
	font-size: medium !important;
    }
    .small {
	font-size: small !important;
    }
    .medium {
	font-size: medium !important;
    }
    .large {
	font-size: large !important;
    }

</style>